import { useMemo } from 'react';
import useTrackingCore from './core';

export default function useCustomizationTracking() {
  const {
    trackEventWithCouponTotalTicketsAndTimeRemaining,
    trackLeavePageEvent,
  } = useTrackingCore();

  const customizationTrackingFunctions = useMemo(() => {
    return {
      customizationViewed: () => {
        trackEventWithCouponTotalTicketsAndTimeRemaining(
          'personalization_viewed',
        );
      },
      customizationClicked: () => {
        trackEventWithCouponTotalTicketsAndTimeRemaining(
          'personalization_clicked',
        );
      },
      customizationSkipClicked: (ticketsToCustomize) => {
        trackEventWithCouponTotalTicketsAndTimeRemaining(
          'personalization_skip_clicked',
          {
            total_tickets: ticketsToCustomize,
          },
        );
      },
      customizationContinueClicked: (ticketsToCustomize) => {
        trackEventWithCouponTotalTicketsAndTimeRemaining(
          'personalization_continue_clicked',
          {
            tickets_named_count: ticketsToCustomize,
          },
        );
      },
      customizationAbandoned: (reason = 'manual_exit') => {
        trackLeavePageEvent('personalization_abandoned', {
          reason,
        });
      },
      surveyViewed: () => {
        trackEventWithCouponTotalTicketsAndTimeRemaining('survey_viewed');
      },
      surveySaved: () => {
        trackEventWithCouponTotalTicketsAndTimeRemaining('survey_saved');
      },
    };
  }, [trackEventWithCouponTotalTicketsAndTimeRemaining, trackLeavePageEvent]);

  return customizationTrackingFunctions;
}
